import { FC } from "react";
import { Alert, Text } from "@chakra-ui/react";

const ActivatedMessage: FC = () => (
  <Alert.Root
    status="success"
    m={{ md: -5 }}
    w={{ md: "calc(100% + (var(--chakra-spacing-5) * 2))" }}
  >
    <Alert.Indicator />
    <Alert.Content>
      <Alert.Description>
        <Text>
          Congratulations! Your account is activated and you can now log in.
        </Text>
      </Alert.Description>
    </Alert.Content>
  </Alert.Root>
);

export default ActivatedMessage;
